import { RootState } from '../store'

export const selectorIsLoading = (state: RootState) => state.loading.isLoading
export const selectorIsLoader = (state: RootState) => state.loading.isLoader
export const selectorIsLoaderMessage = (state: RootState) =>
  state.loading.isLoaderMessage
